import { useState, useRef } from 'react';
import styled from '@emotion/styled';
import Icon from 'components/Kizen/Icon';
import IconButton from 'components/Kizen/IconButton';
import { colorsButton } from 'app/colors';
import { ICON_BUTTON_SIZING } from 'components/Kizen/IconButton';
import MobileActivitySelector from 'pages/Common/MobileActivitySelector';
import MobileAutomationSelector from 'pages/Common/MobileAutomationSelector';

const IconBar = styled.div`
  flex: 1;
  display: flex;
  justify-content: ${({ condensed }) => (condensed ? 'flex-end' : 'center')};
  position: relative;

  // Handle the StagedSelect wrapped in a div to style the menu header/footer
  > a,
  > div > a,
  > button,
  > div > button {
    transition: box-shadow 0.5s ease-in-out;
    transition: padding 0.5s ease-in-out;
    padding: ${({ condensed }) => (condensed ? '0 10px' : '0 15px')};

    > i {
      transition-property: opacity;
      transition-duration: 0.5s;
      transition-timing-function: ease-in-out;
    }

    &:hover i {
      color: var(--color-background-darker);
    }
  }
  &.is-scrolled {
    > a,
    div > a,
    > button,
    > div > button {
      cursor: default;
      border-color: transparent;
      box-shadow: none;
      > i {
        opacity: 0 !important;
      }
    }
  }
`;

const StyledIconButton = styled(IconButton)`
  margin-left: 10px;
  margin-right: 10px;
  && > :first-child {
    color: ${({ color }) =>
      typeof color === 'string' ? color : color.light || color.hover};
  }
  &&:hover > :first-child {
    color: ${({ color }) =>
      typeof color === 'string' ? color : color.dark || color.default};
  }
`;

const ActionBar = ({
  condensed = false,
  hasEditAccess,
  scrolled,
  onStartAutomation,
  defaultOnActivities,
  canStartAutomations,
  customObjectId,
}) => {
  const [showLogActivity, setShowLogActivity] = useState(false);
  const actionButtonRef = useRef(null);

  const [showSelectedAutomation, setShowSelectedAutomation] = useState();
  const automationButtonRef = useRef(null);

  return (
    <IconBar
      className={scrolled ? 'is-scrolled' : ''}
      condensed={condensed}
      scrolled={scrolled}
    >
      {defaultOnActivities ? (
        <>
          {/* log activity */}
          <StyledIconButton
            sizing={ICON_BUTTON_SIZING.overlay}
            color={colorsButton.iconGray}
            borderColor="var(--color-border-medium)"
            onClick={() => setShowLogActivity(true)}
            ref={actionButtonRef}
          >
            <Icon icon="clipboard-check" />
          </StyledIconButton>
          <MobileActivitySelector
            showLogActivity={showLogActivity}
            target={actionButtonRef.current}
            customObjectId={customObjectId}
            onSetVisible={(val) => setShowLogActivity(val)}
            scrolled={scrolled}
            shownScrolled={false}
          />
        </>
      ) : null}
      {/* automation */}
      {canStartAutomations && hasEditAccess ? (
        <StyledIconButton
          sizing={ICON_BUTTON_SIZING.overlay}
          color={colorsButton.iconGray}
          borderColor="var(--color-border-medium)"
          onClick={() => setShowSelectedAutomation(true)}
          ref={automationButtonRef}
        >
          <Icon icon="play" />
        </StyledIconButton>
      ) : null}
      <MobileAutomationSelector
        showSelectedAutomation={showSelectedAutomation}
        target={automationButtonRef.current}
        onSetVisible={(val) => setShowSelectedAutomation(val)}
        scrolled={scrolled}
        shownScrolled={false}
        onStartAutomation={onStartAutomation}
        customObjectId={customObjectId}
      />
    </IconBar>
  );
};

export default ActionBar;
